import { MobileShell } from '@/layouts/mobile/MobileShell';

export function EmployeeMobileLayout() {
  return <MobileShell variant="employee" defaultTitle="首页" />;
}
